import { Toast } from "./toasts"


export const CheckErrors = ({ element, data }) => new Promise((resolve, reject) => {
  if (data) {
    if (data.error && data.data.errors?.length) {
      Toast(element, { error: true, message: data.data.errors[0].error });
      reject(data);
    }
    else {
      resolve(data);
    };
  }
})
